import { TLocale } from "@rsonav/shared-config";
import { EArticleType } from "@rsonav/protocol";

export const articleTypes: { [key: string]: keyof TLocale } = {
	[EArticleType.News]: "news_typeNews",
	[EArticleType.Help]: "news_typeHelp",
	[EArticleType.Law]: "news_typeLaw",
};
